const CONTRACT_ADDRESSES = {
    goerli: {
        PROPOSER_REGISTRY: '0x1643ec804d944Da97d90c013cBaCD1358Cce1bAF',
        BUILDER_REGISTRY: '0x00656DE73Ca420c3e576ac071DF096E1499D7939',
        PAYOUT_POOL: '0xC74A620dd38e19B89395841D50e16D1e215C397e',
        REPORTER_REGISTRY: '0x7Bd41aE3a7d6c66a55C94332689989A9842cC73A',
        SIGNATURE_SWAPPER: '0x91c1c55B40eAdAAE4764105856eD620e5C7ee06C'
    },
    mainnet: {
        PROPOSER_REGISTRY: '0xF7F6D8F8b76E94379034d333f4B5FE1694A32D87',
        BUILDER_REGISTRY: '0xBC8C9B715f76D7b44fC0A195aDd1d113D9853C20',
        PAYOUT_POOL: '0xd242d52B118809d769aDAeD939C509f399cc81A7',
        REPORTER_REGISTRY: '0x67Db92a1C0F485Bf5AE3362C83B74D0c58cA57E6',
        SIGNATURE_SWAPPER: '0xB17f39b4b69ddB0573533c0a621f278B2037B04A'
    }
}

const SIGNATURE_SWAPPER = {
    goerli: 'https://goerli-signature-swapper.ponrelay.com/signature-swap',
    mainnet: 'https://signature-swapper.ponrelay.com/signature-swap'
}

const BUILDER_SIGNATURE_SWAPPER = {
    goerli: 'https://goerli-bls-registration.ponrelay.com/signature-swap',
    mainnet: 'https://bls-registration.ponrelay.com/signature-swap'
}

const chainIdToNetworkmap = {
    1: 'mainnet',
    5: 'goerli'
}

module.exports = {
    CONTRACT_ADDRESSES,
    SIGNATURE_SWAPPER,
    BUILDER_SIGNATURE_SWAPPER,
    chainIdToNetworkmap
}
